import PageIndex from './src/index-alive';
export default PageIndex;